"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unistUtilRemove = _interopRequireDefault(require("unist-util-remove"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      reporter = _ref.reporter;

  return function (tree) {
    var imports = tree.children.filter(function (item) {
      return item.type === 'import';
    }).map(function (item) {
      return item.value;
    }).join('\n');
    (0, _unistUtilRemove.default)(tree, 'import');
    if (reporter) reporter(imports);
  };
};

exports.default = _default;